import ImportHoldings from "./../../components/AddHoldings.vue";
import Portfolio from "./../../components/PortfolioReport.vue";
import StandardChartered from "./../../components/StandardChartered.vue";
import store from "../../store";
import { mapGetters, mapState } from "vuex";

export default {
  name: "importHolding",
  components: { ImportHoldings, Portfolio, StandardChartered  },
  store,

  computed: {
    ...mapState({
      enableReport: state => {
        return state.addholdings.enableReport
      },
      is_premium: state => {
        return state.addholdings.is_premium
      },
      imgPath(){
      return "https://storage.googleapis.com/mscharts/portfoliosmith/";
    },
      userData() {
        return this.$store.state.authentication.user;
      }

    }),
    ...mapGetters("addholdings", {
      alphaScopeData: "alphaScopeData",
      transactionData: "transactionData"
    })
  },

};



// WEBPACK FOOTER //
// ./src/assets/js/importHoldings.js